<script>

    import { toast } from 'bulma-toast'
    import { errorStore, errorsStore, modalStore } from '../stores'

    import ErrorsService from '../$services/errors.service'
    import DateMethod from '../$methods/date.method'
    import NumeralMethods from '../$methods/numeral.methods'

    import TableInformation from '../$components/table.information.svelte'
    import ButtonDelete from '../$components/button.delete.svelte'

    let loading = false

    $: pickup = $errorStore.request && $errorStore.request.pickup
    $: delivery = $errorStore.request && $errorStore.request.delivery
    $: ipackage = $errorStore.quotation && $errorStore.quotation.package

    async function deleteError() {

        loading = true
        const resp = await ErrorsService.deleteError($errorStore._id)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        errorsStore.remove($errorStore._id)

        toast({message: 'Error eliminado', type: 'is-success'})
        modalStore.close()
    }

</script>

<TableInformation { loading }>
    <tbody>
        <tr>
            <th>Fecha</th>
            <td>{ DateMethod.dateTimeLarge($errorStore.created) }</td>
        </tr>
        <tr>
            <th>Código</th>
            <td><code>{ $errorStore.code }</code></td>
        </tr>
        {#if $errorStore.message}
            <tr>
                <th>Mensaje</th>
                <td>{ $errorStore.message }</td>
            </tr>
        {/if}
        {#if $errorStore.user && $errorStore.user.name}
            <tr>
                <th>Usuario</th>
                <td>
                    <div>{ $errorStore.user.name }</div>
                    <div><b>{ $errorStore.user.email }</b></div>
                </td>
            </tr>
        {/if}
        <tr>
            <th>Servicio</th>
            <td>
                <div><b>Partner:</b> { $errorStore.partner || $errorStore.provider }</div>
                <div><b>Proveedor:</b> { $errorStore.provider }</div>
                <div><b>Servicio:</b> { $errorStore.service }</div>
            </td>
        </tr>
        {#if pickup}
            <tr>
                <th>Origen</th>
                <td>
                    <div><b>Contacto:</b> { pickup.contact }</div>
                    <div><b>Empresa:</b> { pickup.corporate }</div>
                    <div><b>RFC:</b> { pickup.rfc || 'Sin RFC' }</div>
                    <div><b>Teléfono:</b> { pickup.phone }</div>
                    <div><b>Email:</b> { pickup.email }</div>
                    <div><b>Código postal:</b> { $errorStore.quotation?.pickup?.zipcode }</div>
                    <div><b>Estado:</b> { pickup.state }</div>
                    <div><b>Ciudad:</b> { pickup.city }</div>
                    <div><b>Municipio:</b> { pickup.municipality }</div>
                    <div><b>Colonia:</b> { pickup.colony }</div>
                    <div><b>Calle:</b> { pickup.street }</div>
                    <div><b>Número:</b> { pickup.number }</div>
                    <div><b>Apartamento:</b> { pickup.apartment }</div>
                    <div><b>Referencias:</b> { pickup.references || 'Sin referencias' }</div>
                </td>
            </tr>
        {/if}
        {#if delivery}
            <tr>
                <th>Destino</th>
                <td>
                    <div><b>Contacto:</b> { delivery.contact }</div>
                    <div><b>Empresa:</b> { delivery.corporate }</div>
                    <div><b>RFC:</b> { delivery.rfc || 'Sin RFC' }</div>
                    <div><b>Teléfono:</b> { delivery.phone }</div>
                    <div><b>Email:</b> { delivery.email }</div>
                    <div><b>Código postal:</b> { $errorStore.quotation?.delivery?.zipcode }</div>
                    <div><b>Estado:</b> { delivery.state }</div>
                    <div><b>Ciudad:</b> { delivery.city }</div>
                    <div><b>Municipio:</b> { delivery.municipality }</div>
                    <div><b>Colonia:</b> { delivery.colony }</div>
                    <div><b>Calle:</b> { delivery.street }</div>
                    <div><b>Número:</b> { delivery.number }</div>
                    <div><b>Apartamento:</b> { delivery.apartment }</div>
                    <div><b>Referencias:</b> { delivery.references || 'Sin referencias' }</div>
                </td>
            </tr>
        {/if}
        {#if ipackage}
            <tr>
                <th>Paquete</th>
                <td>
                    <div><b>Ancho:</b> { ipackage.width } cm</div>
                    <div><b>Alto:</b> { ipackage.height } cm</div>
                    <div><b>Largo:</b> { ipackage.length } cm</div>
                    <div><b>Peso:</b> { ipackage.weight } kg</div>
                    <div><b>Valor:</b> { NumeralMethods.cash(ipackage.value) } MXN</div>
                    <div><b>Descripción:</b> { $errorStore.request.packageContent || 'Sin descripción' }</div>
                </td>
            </tr>
        {/if}
        {#if $errorStore.analysis}
            <tr>
                <th>Analisis del error</th>
                <td>
                    <pre class="is-size-7" style="white-space: pre-wrap; word-break: break-all;">{ JSON.stringify($errorStore.analysis, null, 2) }</pre>
                </td>
            </tr>
        {/if}
        {#if $errorStore.raw}
            <tr>
                <th>Raw</th>
                <td>
                    <pre class="is-size-7" style="white-space: pre-wrap; word-break: break-all;">{ JSON.stringify($errorStore.raw, null, 2) }</pre>
                </td>
            </tr>
        {/if}
        {#if $errorStore.request}
            <tr>
                <th>Request</th>
                <td>
                    <pre class="is-size-7" style="white-space: pre-wrap; word-break: break-all;">{ JSON.stringify($errorStore.request, null, 2) }</pre>
                </td>
            </tr>
        {/if}
        {#if $errorStore.quotation}
            <tr>
                <th>Cotización</th>
                <td>
                    <pre class="is-size-7" style="white-space: pre-wrap; word-break: break-all;">{ JSON.stringify($errorStore.quotation, null, 2) }</pre>
                </td>
            </tr>
        {/if}
        {#if $errorStore.stack}
            <tr>
                <th>Stack</th>
                <td>
                    <pre class="is-size-7" style="white-space: pre-wrap; word-break: break-all;">{ $errorStore.stack }</pre>
                </td>
            </tr>
        {/if}
        <tr>
            <th></th>
            <td>
                <div class="items-end">
                    <ButtonDelete on:confirm={deleteError} { loading } />
                </div>
            </td>
        </tr>
    </tbody>
</TableInformation>
